import React from 'react'
import { HighlightCard } from 'ui/cards'
import { Translation } from '@morningtrain/react-translations'
import InventoryOrderDaysAdjuster from 'widgets/inventory/InventoryOrderDaysAdjuster'
import InventoryOrderPeriodFormatter from 'widgets/inventory/InventoryOrderPeriodFormatter'
import * as Icons from 'ui/icons'
import WhenOrderIsDraft from 'pages/app/inventory/order/partials/WhenOrderIsDraft'

function InventoryOrderDaysHighlightCard (props) {
  return (
    <WhenOrderIsDraft>
      <HighlightCard
        title={<InventoryOrderPeriodFormatter />}
        box={<Icons.Shifts />}
        content={<Translation name='inventory.order.order_period' />}
        actions={<InventoryOrderDaysAdjuster />}
      />
    </WhenOrderIsDraft>
  )
}

export default InventoryOrderDaysHighlightCard
